import React from "react";
import { FormattedMessage } from "react-intl";
import "../LossLimits.scss";

const LossLimitsText: React.FC = () => {
  return (
    <div className="loss-limits-text">
      <span>
        <FormattedMessage
          id="loss-limits-text-rolling-periods"
          defaultMessage="Limits apply to rolling time periods, e.g., weekly applies to 7 days, where you cannot exceed the limit set in a 7 day period."
        />
      </span>
      <span>
        <FormattedMessage
          id="loss-limits-text-increase"
          defaultMessage="Requests to increase or remove limits can be applied after 24 hours."
        />
      </span>
      <span>
        <FormattedMessage
          id="loss-limits-text-reduce"
          defaultMessage="Requests to reduce limits are automatic."
        />
      </span>
      <span>
        <FormattedMessage
          id="loss-limits-text-potential-loss"
          defaultMessage="Potential loss is calculated at the time of bet placement. Bets already placed but not settled at the time of limit set may not be counted."
        />
      </span>
    </div>
  );
};

export default LossLimitsText;
